import { ShellComponent } from './templates/shell/shell.component';
import { LegacyComponent } from './pages/legacy/legacy.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes, ExtraOptions, RouteReuseStrategy } from '@angular/router';
import { ApiSpecificationEmbedComponent } from './pages/api-specification-embed/api-specification-embed.component';
import { ApiSpecificationPageComponent } from './pages/api-specification-page/api-specification-page.component';
import { FourOhFourComponent } from './pages/four-oh-four/four-oh-four.component';
import { TitleGuard } from './routes/guards/title.guard';
import { CanDeactivateGuard } from './routes/can-deactivate-guard.service';
import { FourOhThreeComponent } from './pages/four-oh-three/four-oh-three.component';
import { LeadGenComponent } from './pages/lead-gen/lead-gen.component';
import { LeadConfirmationComponent } from './pages/lead-confirmation/lead-confirmation.component';
import { PageComponent } from './pages/page/page.component';
import { CustomReuseStrategy } from './routes/custom-reuse-strategy';
import { SelfServiceGuard } from './routes/guards/self-service.guard';
import { RouteExternalGuard } from './routes/guards/route-external.guard';
import { RedirectGuard } from './routes/guards/redirect.guard';
import { LoaderGuard } from './routes/guards/loader.guard';
import { SelectivePreloadStrategy } from './routes/selective-preload.strategy';

const routes: Routes = [
  {
    path: 'styleguide',
    loadChildren: () => import('./modules/styleguide/styleguide.module').then((m) => m.StyleguideModule),
    data: { preload: true, preloadPriority: 4 },
  },
  {
    path: 'styleguide2020',
    redirectTo: '/styleguide',
  },
  {
    path: 'account',
    loadChildren: () => import('./modules/account/account.module').then((m) => m.AccountModule),
    canActivate: [TitleGuard],
    data: { preload: true, preloadPriority: 3 },
    // canDeactivate: [CanDeactivateGuard],
  },
  {
    path: '',
    component: ShellComponent,
    children: [
      {
        path: '404',
        canActivate: [TitleGuard],
        component: FourOhFourComponent,
      },
      {
        path: '403',
        canActivate: [TitleGuard],
        component: FourOhThreeComponent,
      },
      {
        path: 'api-specification/:family/:api/:version',
        component: ApiSpecificationPageComponent,
        canActivate: [LoaderGuard],
        pathMatch: 'full',
        // canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'api-specification/:family/:api',
        component: ApiSpecificationPageComponent,
        canActivate: [LoaderGuard],
        pathMatch: 'full',
        // canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'api-specification/:api',
        component: ApiSpecificationPageComponent,
        canActivate: [LoaderGuard],
        pathMatch: 'full',
        // canDeactivate: [CanDeactivateGuard],
      },
      // {
      //   path: 'contact-sales',
      //   component: LeadGenComponent,
      //   canActivate: [TitleGuard],
      //   canDeactivate: [CanDeactivateGuard],
      // },
      // {
      //   path: 'contact-confirmation',
      //   component: LeadConfirmationComponent,
      //   canActivate: [TitleGuard],
      // canDeactivate: [CanDeactivateGuard],
      // },
      {
        path: 'legacy',
        component: LegacyComponent,
        loadChildren: () => import('./modules/legacy/legacy.module').then((m) => m.LegacyModule),
        data: { preload: true, preloadPriority: 2 },
        // canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'solution-finder',
        loadChildren: () => import('./modules/solution-finder/solution-finder.module').then((m) => m.SolutionFinderModule),
        canActivate: [TitleGuard],
        data: { preload: true, preloadPriority: 1 },
      },
      {
        path: '**',
        component: PageComponent,
        canActivate: [LoaderGuard, RedirectGuard],
        // canDeactivate: [CanDeactivateGuard],
      },
    ],
  },
];

const config: ExtraOptions = {
  onSameUrlNavigation: 'reload',
  preloadingStrategy: SelectivePreloadStrategy,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
  providers: [
    // CanDeactivateGuard,
    RedirectGuard,
    RouteExternalGuard,
    SelfServiceGuard,
    TitleGuard,
    LoaderGuard,
    {
      provide: RouteReuseStrategy,
      useClass: CustomReuseStrategy,
    },
  ],
})
export class AppRoutingModule {}
